import Styled from 'styled-components'
import { maxQuery } from '../../../../helpers'

export default Styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #272B4A;
    cursor: pointer;
    padding: 2em 1em;
    border: 0.688106px solid rgba(255, 255, 255, 0.1);
    border-radius: 2.77041px;
    height: fit-content;
    transition: all 0.2s ease;
    
    &:hover {
        border-color: ${({ theme }) => theme.primary};
        transform: translateY(-2px);
    }
    
    div.img--container {
        width: 7rem;
        height: 6rem;
        border-radius: 50%;
        margin-bottom: 1.2em;
        display: flex;
        align-items: center;
        border: 1px solid ${({ theme }) => theme.primary};
        justify-content: center;
        color: ${({ theme }) => theme.primary};
        font-size: 1.5rem;
        font-weight: 600;
    }
    
    h3 {
        font-weight: 500;
        font-size: 1rem;
        text-align:center;
        margin-bottom: 0.5em;
        color: rgba(255, 255, 255, 0.9);
    }
    
    p {
        font-size: 0.9rem;
        color: rgba(255, 255, 255, 0.7);
        text-align: center;
        ${maxQuery('sm')} {
            font-size: 0.8rem;
        }
        :not(:last-child) {
            margin-bottom: 1em;
        }
    }
    
    .role-badge {
        display: inline-block;
        padding: 0.4em 1em;
        border-radius: 20px;
        font-size: 0.8rem;
        font-weight: 600;
        text-transform: uppercase;
        margin-top: 0.5em;
        
        &.super_admin {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: #fff;
        }
        
        &.admin {
            background: #6ABA6D;
            color: #fff;
        }
        
        &.moderator {
            background: #f39c12;
            color: #fff;
        }
    }
`
